<template>
  <div class="login-caih-container">
    <el-image class="bg-img" :src="bgUrl" />
    <div class="m-header">
      <el-image class="caih-logo" :src="caihLogo" />
      <div class="m-divider"></div>
      <span class="m-header-txt">视频管理平台</span>
    </div>
    <el-image class="camera-img" :src="cameraUrl" />
    <div class="login-form">
      <div class="login-form-title">
        <span class="title-1">用户登录</span>
        <span class="title-2">LOGIN</span>
      </div>
      <el-input
        v-model="username"
        style="margin-top: 24px"
        prefix-icon="el-icon-user"
        placeholder="请输入用户名"
      ></el-input>
      <el-input
        v-model="password"
        type="password"
        show-password
        style="margin-top: 24px"
        prefix-icon="el-icon-lock"
        placeholder="请输入密码"
      ></el-input>
      <el-button
        style="margin-top: 24px; width: 100%"
        type="primary"
        :loading="isLoading"
        @click="login"
        >登录</el-button
      >
    </div>
  </div>
</template>

<script>
import crypto from 'crypto';
import userService from './service/UserService';
export default {
  data() {
    return {
      bgUrl: require('@/assets/caih-login-bg.png'),
      cameraUrl: require('@/assets/caih-login-camera.png'),
      caihLogo: require('@/assets/caih-logo-white.png'),
      username: '',
      password: '',
      isLoading: false
    };
  },
  created() {
    var that = this;
    document.onkeydown = function (e) {
      var key = window.event.keyCode;
      if (key == 13) {
        that.login();
      }
    };
  },
  methods: {
    login() {
      if (this.username != '' && this.password != '') {
        this.toLogin();
      }
    },
    cancelEnterkeyDefaultAction: function () {
      document.onkeydown = function (e) {
        var key = window.event.keyCode;
        if (key == 13) {
          return false;
        }
      };
    },
    //登录请求
    toLogin() {
      //需要想后端发送的登录参数
      let loginParam = {
        username: this.username,
        password: crypto
          .createHash('md5')
          .update(this.password, 'utf8')
          .digest('hex')
      };
      var that = this;
      //设置在登录状态
      this.isLoging = true;
      let timeoutTask = setTimeout(() => {
        that.$message.error('登录超时');
        that.isLoging = false;
      }, 1000);

      this.$axios({
        method: 'get',
        url: '/api/user/login',
        params: loginParam
      })
        .then(function (res) {
          window.clearTimeout(timeoutTask);
          console.log(res);
          console.log('登录成功');
          if (res.data.code === 0) {
            userService.setUser(res.data.data);
            //登录成功后
            that.cancelEnterkeyDefaultAction();
            that.$router.push('/');
          } else {
            that.isLoging = false;
            that.$message({
              showClose: true,
              message: '登录失败，用户名或密码错误',
              type: 'error'
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          window.clearTimeout(timeoutTask);
          that.$message.error(error.response.data.msg);
          that.isLoging = false;
        });
    }
  }
};
</script>

<style scoped>
.login-caih-container {
  width: 100vw;
  height: 100vh;
  position: relative;
}

.m-header {
  position: absolute;
  display: flex;
  top: 12px;
  left: 10px;
  align-items: center;
}

.m-divider {
  background: #fff;
  width: 1px;
  height: 32px;
  margin-left: 12px;
}

.m-header-txt {
  font-family: Arial;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 1.09px;
  font-weight: 700;
  margin-left: 12px;
}

.bg-img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.camera-img {
  position: absolute;
  top: 10vw;
  left: 20vh;
  height: 68vh;
  width: 44vw;
}

.login-form {
  position: absolute;
  top: 33vh;
  right: 18vw;
  background: #fff;
  border-radius: 4px;
  width: 320px;
  height: 228px;
  padding: 48px;
}

.title-1 {
  font-family: Arial;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 26px;
  font-weight: 700;
}

.title-2 {
  font-family: Arial;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.25);
  line-height: 26px;
  font-weight: 700;
}
</style>


// WEBPACK FOOTER //
// src/components/LoginCaih.vue